import { useMutation } from '@metorial/data-hooks';
import { withDashboardSDK } from '@metorial/state/src/sdk';

let logout = () => withDashboardSDK(sdk => sdk.auth.logout());

export let useLogout = () => useMutation(logout);
